import { useTranslation } from '@mukil/i18n';
import { InfoBanner } from '@jumpstone/ui-react';

/**
 * Dismissible explainer for the four worker types, shown under the
 * directory header. The contractor line is the important one: contractors
 * must be genuinely self-employed, are recorded for reference only, are
 * never in pay runs / statutory contributions / leave, and are paid through
 * bills.
 */
export function WorkerTypesBanner(): React.JSX.Element {
  const { t } = useTranslation('wp');
  return (
    <div className="mb-4">
      <InfoBanner
        dismissible
        storageKey="wp.employees.worker_types_banner"
        title={t('employees.worker_types_banner_title')}
      >
        {/* One line per worker type, in WORKER_TYPE_ORDER. */}
        <ul className="list-disc ps-5 space-y-1">
          <li>{t('employees.worker_types_banner_full_time')}</li>
          <li>{t('employees.worker_types_banner_part_time')}</li>
          <li>{t('employees.worker_types_banner_contract')}</li>
          <li>{t('employees.worker_types_banner_contractor')}</li>
        </ul>
      </InfoBanner>
    </div>
  );
}
